var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"item",class:{ active: _vm.active },attrs:{"to":_vm.route},nativeOn:{"click":function($event){_vm.hideSideBar()}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }